import React from 'react';
import Icon from '../../../components/AppIcon';

const ProofHeader = ({ currentProof, totalProofs, challengeTitle, onClose }) => {
  return (
    <div className="flex items-center justify-between mb-4 md:mb-6">
      <div className="flex-1 min-w-0">
        <div className="flex items-center space-x-3 mb-2">
          <div className="w-10 h-10 bg-primary/20 rounded-md flex items-center justify-center">
            <Icon name="Image" size={20} color="var(--color-primary)" />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground truncate">
              {challengeTitle}
            </h2>
            <p className="text-xs md:text-sm text-muted-foreground caption">
              증명 {currentProof} / {totalProofs}
            </p>
          </div>
        </div>
      </div>

      <button
        onClick={onClose}
        className="flex-shrink-0 w-10 h-10 rounded-md flex items-center justify-center transition-gaming hover:bg-muted ml-4"
        aria-label="Close modal"
      >
        <Icon name="X" size={24} color="var(--color-foreground)" />
      </button>
    </div>
  );
};

export default ProofHeader;